
import { forwardRef, useImperativeHandle, useRef, useEffect } from "react";
import useForm from "../../hooks/useForm";
import {
  initialTinas,
  propsTinas,
} from "../../utils/formsInitialsStates";

interface Props {
  handleSubmit?: (values: propsTinas) => void;
  data?: propsTinas;
  on?: string;
}

export const TinaForm = forwardRef(
  ({ handleSubmit, data, on }: Props, ref) => {
    const {
      handleInputChange,
      formValues,
      resetForm,
      changeMulti,
      validateForm,
    } = useForm<propsTinas>(initialTinas);
    const form = useRef<HTMLFormElement>(null);

    const submitForm = (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      handleSubmit && handleSubmit(formValues);
    };
    useImperativeHandle(ref, () => ({
      handleClick: () => {
        form.current?.requestSubmit();
        if (form.current && validateForm(form.current.elements)) {
          return formValues;
        }
      },
      resetForm: () => resetForm(),
    }));
    useEffect(() => {
      if (data) changeMulti(data);
    }, [data, changeMulti]);

    return (
      <form
        className="p-2"
        id="formBancos"
        ref={form}
        autoComplete="off"
        onSubmit={submitForm}
        noValidate
      >
        <div className="row">
          <div className="col-md-8">
            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                id="nombre_tina"
                name="nombre_tina"
                value={formValues.nombre_tina}
                onChange={handleInputChange}
                placeholder="-"
                data-uppercase="change"
                data-trim="submit"
                required
              />
              <label htmlFor="nombre_tina">Nombre de la tina</label>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-8">
            <div className="form-floating mb-3">
              <input
                type="number"
                className="form-control"
                id="capacidad"
                name="capacidad"
                value={formValues.capacidad}
                onChange={handleInputChange}
                placeholder="-"
                data-type="number"
                data-min={0}
                required
              />
              <label htmlFor="capacidad">Indique capacidad en litros</label>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-8">
            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                id="descripcion"
                name="descripcion"
                value={formValues.descripcion}
                onChange={handleInputChange}
                placeholder="Descripción..."
                required
              />
              <label htmlFor="descripcion">Descripción de la tina</label>
            </div>
          </div>
        </div>

        <div className="row">
        <div className="col-md-8">
          <div className="form-floating mb-3">
            <select className="form-select" id="estado" name="estado" value={Number(formValues.estado)} onChange={handleInputChange} required>
              <option value="" disabled>Seleccione un estado</option>
              <option value={1}>Habilitado</option>
              <option value={0}>Inhabilitado</option>
            </select>
            <label htmlFor="estado">Habilitar/Inhabilitar</label>
          </div>
        </div>
        </div>
      </form>
    );
  }
);